import React from 'react'
import { IconText } from '../../../index'
import { IconSuccessFilled } from '@s4l/icons/IconSuccessFilled'

import styles from './index.module.css'

interface IFeatureProps {
  children: React.ReactNode
}

function Feature({ children }: Readonly<IFeatureProps>) {
  return (
    <IconText icon={<IconSuccessFilled color="var(--color-success-500)" />} size="l">
      <span className={styles.text}>{children}</span>
    </IconText>
  )
}

export default Feature
